import type { CreateServiceRequestItemInput } from '@hotel-voice/shared';
import type { LaundryService } from '@/types';

/**
 * Laundry is a set of ticked services and a note — no quantities, no weights.
 * The guest is told the price per item or per kg; staff settle the actual
 * charge when the clothes are collected.
 */
export type LaundrySelection = ReadonlySet<string>;

export function toggleLaundryService(selection: LaundrySelection, serviceId: string): LaundrySelection {
  const next = new Set(selection);
  if (next.has(serviceId)) next.delete(serviceId);
  else next.add(serviceId);
  return next;
}

/** Ticked services in catalogue order; ids no longer offered are dropped. */
export function selectedLaundry(
  selection: LaundrySelection,
  services: readonly LaundryService[],
): LaundryService[] {
  return services.filter((service) => selection.has(service.id));
}

export function toRequestItems(selected: readonly LaundryService[]): CreateServiceRequestItemInput[] {
  return selected.map((service) => ({ id: service.id }));
}
